/* eslint-disable */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Divider, Grid, Button } from 'semantic-ui-react';

import * as AppActions from '../../actions';
import {
  insertCarousel,
  insertCarouselCard,
  updateCarousel,
  removeCarouselCards
} from '../../services/CarouselService';
import CarouselCard from './CarouselCard';
import './CarouselBuilder.css';

class CarouselBuilder extends Component {
  state = {
    token: this.props.getFbToken(),
    message: '',
    errorMessage: '',
    form: {
      name: '',
      body: '',
      cards: this.props.carouselToEdit
        ? []
        : [
            {
              id: '',
              cardName: '',
              description: '',
              image_url: '',
              video: '',
              link: '<Product 1 Link>',
              call_to_action: 'LEARN_MORE'
            }
          ]
    }
  };

  componentDidMount() {
    if (this.props.carouselToEdit) {
      this.initializeEdit(this.props.carouselToEdit);
    }
  }

  initializeEdit = async (carouselToEdit) => {
    let form = this.state.form;
    form.name = carouselToEdit.name;
    form.body = carouselToEdit.body;
    form.cards = carouselToEdit.cards;

    this.setState({ form });
  };

  clearFields = () => {
    const form = {
      name: '',
      body: '',
      cards: []
    };

    this.setState({ form });
    form.cards = [
      {
        id: '',
        cardName: '',
        description: '',
        image_url: '',
        video: '',
        link: '<Product 1 Link>',
        call_to_action: 'LEARN_MORE'
      }
    ];

    this.setState({ form });
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  handleCardChange = (event, { name, value }) => {
    const cardNumber = event.target.id - 1;
    let form = this.state.form;
    let card = form.cards[cardNumber];
    card[name] = value;
    form.cards[cardNumber] = card;
    this.setState({ form });
  };

  goBackSearch = () => {
    this.clearFields();
    this.props.searchPage();
  };

  saveCarousel = async () => {
    this.setState({ message: '', errorMessage: '' });

    const carousel = {
      name: this.state.form.name,
      body: this.state.form.body,
      display_link: '',
      user: this.props.user.email
    };

    let result = {};
    if (this.props.carouselToEdit) {
      carousel.id = this.props.carouselToEdit.id;
      await updateCarousel(carousel);
      await removeCarouselCards(this.props.carouselToEdit.id);
      result.id = this.props.carouselToEdit.id;
    } else {
      result = await insertCarousel(carousel);
    }

    if (result.id) {
      this.state.form.cards.map(async (card, index) => {
        const newCard = {
          name: card.cardName,
          description: card.description,
          image_url: card.image_url,
          video: card.video,
          link: card.link,
          call_to_action: card.call_to_action,
          carousel_id: result.id,
          order: index + 1
        };
        const resultCard = await insertCarouselCard(newCard);
      });

      this.setState({
        message:
          'The Carousel has been ' +
          (this.props.carouselToEdit ? 'updated' : 'created')
      });
      if (!this.props.carouselToEdit) {
        this.clearFields();
      }
    } else {
      this.setState({ errorMessage: 'The Carousel was not saved' });
    }
  };

  addCard = () => {
    let form = this.state.form;
    const link = '<Product ' + (this.state.form.cards.length + 1) + ' Link>';
    form.cards.push({
      id: '',
      cardName: '',
      description: '',
      image_url: '',
      video: '',
      link,
      call_to_action: 'LEARN_MORE'
    });
    this.setState({ form });
  };

  removeCard = (index) => {
    let form = this.state.form;
    form.cards.splice(index - 1, 1);
    form.cards.map((card, key) => {
      card.link = '<Product ' + (key + 1) + ' Link>';
    });
    this.setState({ form });
  };

  swapCard = (cardNumber, direction) => {
    let form = this.state.form;
    const currentElem = this.state.form.cards[cardNumber - 1];
    if (direction === 'left') {
      this.state.form.cards[cardNumber - 1] = this.state.form.cards[
        cardNumber - 2
      ];
      this.state.form.cards[cardNumber - 2] = currentElem;
    } else {
      this.state.form.cards[cardNumber - 1] = this.state.form.cards[cardNumber];
      this.state.form.cards[cardNumber] = currentElem;
    }

    this.setState({ form });
  };

  render() {
    const { name, body } = this.state.form;
    return (
      <div>
        <div>
          <Button onClick={this.goBackSearch} size="small" color="blue">
            Back
          </Button>
          <Button onClick={this.saveCarousel} size="small" color="blue">
            Save
          </Button>
          {this.state.message ? (
            <div className="message-container">
              <span>{this.state.message}</span>
            </div>
          ) : null}
          {this.state.errorMessage ? (
            <div className="error-message-container">
              <span>{this.state.errorMessage}</span>
            </div>
          ) : null}
        </div>
        <Divider hidden />
        <Form>
          <Form.Input
            className="input-text-carousel"
            placeholder="Carousel Name"
            type="text"
            name="name"
            value={name}
            onChange={this.handleFormChange}
          />
          <Divider hidden />
          <Form.Input
            className="input-text-carousel-body"
            placeholder="Carousel Body"
            type="text"
            name="body"
            value={body}
            onChange={this.handleFormChange}
          />
        </Form>
        <Divider hidden />
        <Grid>
          <Grid.Row columns={5}>
            {this.state.form.cards.slice(0, 5).map((card, index) => (
              <Grid.Column>
                <CarouselCard
                  card={card}
                  totalCards={this.state.form.cards.length}
                  editId={card.id}
                  key={card.id}
                  swapCard={this.swapCard}
                  edit={this.props.carouselToEdit !== ''}
                  cardNumber={index + 1}
                  handleCardChange={this.handleCardChange}
                  removeCard={this.removeCard}
                  getFbToken={this.props.getFbToken}
                />
              </Grid.Column>
            ))}
            {this.state.form.cards.length < 5 ? (
              <Grid.Column>
                <CarouselCard
                  addCard={this.addCard}
                  getFbToken={this.props.getFbToken}
                />
              </Grid.Column>
            ) : null}
          </Grid.Row>
          <Grid.Row columns={5}>
            {this.state.form.cards.length > 5
              ? this.state.form.cards.slice(5).map((card, index) => (
                  <Grid.Column>
                    <CarouselCard
                      card={card}
                      totalCards={this.state.form.cards.length}
                      swapCard={this.swapCard}
                      editId={card.id}
                      key={card.id}
                      edit={this.props.carouselToEdit !== ''}
                      cardNumber={index + 6}
                      handleCardChange={this.handleCardChange}
                      removeCard={this.removeCard}
                      getFbToken={this.props.getFbToken}
                    />
                  </Grid.Column>
                ))
              : null}
            {this.state.form.cards.length >= 5 &&
            this.state.form.cards.length < 10 ? (
              <Grid.Column>
                <CarouselCard
                  addCard={this.addCard}
                  getFbToken={this.props.getFbToken}
                />
              </Grid.Column>
            ) : null}
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CarouselBuilder);



// WEBPACK FOOTER //
// ./src/screens/Carousel/CarouselBuilder.js